import { AfterContentChecked, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnexoRepository } from '@app/data/anexo/anexo.repository'; 
import { DetalhesAtendimentoComponent } from '@app/modules/atendimentos/components/detalhes-atendimento/detalhes-atendimento.component';
import { modal } from '@app/shared/alerts/modal/modal.alert';
import { AnexosComponent } from '@app/shared/components/anexos/anexos.component';
import { FileData } from '@app/shared/components/anexos/file/file.component'; 

@Component({
  selector: 'app-anexo-pneu',
  templateUrl: './anexo-pneu.component.html',
  styleUrls: ['./anexo-pneu.component.scss']
})
export class AnexoPneuComponent implements AfterContentChecked {
  @ViewChild('anexos') anexos: AnexosComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { codigoOrdemServico: string },
    private dialogRef: MatDialogRef<DetalhesAtendimentoComponent>,
    private changeDetector: ChangeDetectorRef, 
    private anexoRepository: AnexoRepository,
  ) { }

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.anexoRepository.getAnexos('OrdemServicos', this.data.codigoOrdemServico).subscribe((data) => {
      if (this.anexos) {
        this.anexos.setSentFiles(data);
      }
    });
  }

  protected onClose() {
    this.dialogRef.close(false);
  }

  protected onSubmit(anexos: FileData[]) {
    if (anexos.length > 0)
      this.anexoRepository.postAnexos('OrdemServicos', this.data.codigoOrdemServico, anexos).subscribe({
        next: () => {
          this.dialogRef.close(true);
        },
        error: () => {
          modal.fire({
            icon: 'error',
            title: 'Erro ao salvar anexos',
            html: 'Tente novamente mais tarde.',
          });

          this.dialogRef.close(false);
        },
      })
  }
}
